
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/article/[id]",
      function () {
        return require("private-next-pages/help/article/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/article/[id]"])
      });
    }
  